import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgControl, ReactiveFormsModule } from '@angular/forms';
import { AppendTestIdPipe } from '../../../../pipes/append-test-id/append-test-id.pipe';
import { ErrorMessageComponent } from '../../../layout/error-message/error-message.component';
import { FormTranslationInputComponent } from '../form-translation-input.component';

@Component({
  selector: 'aw-translation-text-input',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AppendTestIdPipe,
    ErrorMessageComponent,
  ],
  templateUrl: './translation-text-input.component.html',
})
export class TranslationTextInputComponent
  extends FormTranslationInputComponent
  implements OnInit, OnDestroy
{
  constructor(public override ngControl: NgControl) {
    super(ngControl);
  }
}
